import React from "react";
import { useNavigate } from "react-router-dom";

const LoginButton = () => {
  const navigate = useNavigate();
  const handleLoginClick = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className="btn-wrapper position-relative">
      <button onClick={handleLoginClick}>
       Login
      </button>
    </div>
  );
};

export default LoginButton;
